export default __webpack_public_path__ + "static/media/caleb-breath-icon.e204acf6.svg";